import React from 'react';
import ShellPageLayout from '../../components/ShellPageLayout';

/**
 * Admin page layout wrapper — delegates to the shared ShellPageLayout.
 *
 * Uses standard `p-6` padding (non-compact).
 */
export default function AdminLayout({ children, title, description, actions }) {
    return (
        <ShellPageLayout title={title} description={description} actions={actions}>
            {children}
        </ShellPageLayout>
    );
}
